import {drilldownActions} from '../../editor-interface/shared/models/map.model';

const menuItems = {
  separator: '-',
  color: 'paperStyle',
  addToLegend: 'addToLegend',

  attachNote: 'attachNote',
  attachUrl: 'attachUrl',
  attachImage: 'attachImage',
  attachDataTable: 'attachDataTable',

  refModelNode: 'refModelNode',
  requirement: 'requirement',
  addItemLink: 'addItemLink',
  orgModelNode: 'orgModelNode',
  copiedOrgModelNode: 'copiedOrgModelNode',
  proposedNode: 'proposedNode',

  connectorCopy: 'connectorCopy',
  connectorConnect: 'connectorConnect',

  addAttachment: 'addAttachment',
  addLinks: 'addLinks',
  addChange: 'addChange',
  generate: 'generate',
  addDocumentation: 'addDocumentation',
  addAttribute: 'addAttribute',
  addFooterText: 'addFooterText',
  makeContainerCard: 'makeContainerCard',
  makeNormalCard: 'makeNormalCard',

  addRequirement: 'addRequirement',
  generateRequirement: 'generateRequirement',
  generateRequirements: 'generateRequirements',
  addStory: 'addStory',
  generateStoriesAI: 'generateStoriesAI',
  pasteStoryLink: 'pasteStoryLink',
  pasteRequirementLink: 'pasteRequirementLink',
  addResource: 'addResource',
  resource: 'resource',
  addActivity: 'addActivity',
  addTerminator: 'addTerminator',
  addConnector: 'addConnector',
  addImage: 'addImage',
  addSticker: 'addSticker',

  renumberActivity: 'renumberActivity',
  removeTerminator: 'removeTerminator',

  drilldown: 'drilldown',
  newDrilldown: 'newDrilldown',
  drilldownMenuTitle: 'drilldownMenuTitle',
  upnDrilldown: drilldownActions.upn,
  agentInstructionDrilldown: drilldownActions.agentInstruction,
  agentInteractionDrilldown: drilldownActions.agentInteraction,
  interactionFlowDrilldown: drilldownActions.interactionFlow,
  capabilityDrilldown: drilldownActions.capability,
  dataModelDrilldown: drilldownActions.dataModel,
  customerJourneyDrilldown: drilldownActions.customerJourney,
  systemArchitectureDrilldown: drilldownActions.systemArchitecture,
  importDrilldown: 'importDrilldown',
  exportDrilldown: 'exportDrilldown',
  deleteDrilldown: 'deleteDrilldown',

  paperDefault: 'paperDefault',
  paperGreen: 'paperGreen',
  paperBlue: 'paperBlue',
  paperRed: 'paperRed',

  reverseLine: 'reverseLine',
  choosePoints: 'choosePoints',

  clearWaypoints: 'clearWaypoints',
  makeStraight: 'makeStraight',
  makeAllLinesStraight: 'makeAllLinesStraight',
  addStartText: 'addStartText',
  addEndText: 'addEndText',
  addInteraction: 'addInteraction',
  deleteInteraction: 'deleteInteraction',

  selectVertices: 'selectVertices',
  selectEdges: 'selectEdges',
  selectAll: 'selectAll',
  selectionMenu: 'selectionMenu',
  selectBoxes: 'selectBoxes',
  hideStickers: 'hideStickers',
  showStickers: 'showStickers',
  filterStickers: 'filterStickers',
  filterStickersByUser: 'filterStickersByUser',
  filterStickersByColor: 'filterStickersByColor',
  filterStickersByTag: 'filterStickersByTag',

  zoomIn: 'zoomIn',
  zoomOut: 'zoomOut',

  fitWindow: 'fitWindow',

  smartRenumber: 'smartRenumber',

  paste: 'paste',
  copy: 'copy',
  delete: 'delete',
  pasteStyle: 'pasteStyle',
  copyStyle: 'copyStyle',

  sendToChild: 'sendToChild',
  autoGenerateDrilldown: 'autoGenerateDrilldown',
  useExistingDiagram: 'useExistingDiagram',

  copyConnectorLink: 'copyConnectorLink',
  pasteConnectorLink: 'pasteConnectorLink',

  formatLineStyle: 'formatLineStyle',
  formatActivityThemes: 'formatActivityThemes',
  formatTextThemes: 'formatTextThemes',
  formatConnectorThemes: 'formatConnectorThemes',
  formatTerminatorThemes: 'formatTerminatorThemes',
  lockUnlock: 'lockUnlock',
  toBack: 'toBack',
  toFront: 'toFront',

  addToCard: 'addToCard',
  theme: 'theme',
  themePasteMenu: 'themePasteMenu',
  placement: 'placement',
  lock: 'lock',
  unlock: 'unlock',

  resourcePlacement: 'resourcePlacement',
  resourcePlacementRow: 'resourcePlacementRow',
  resourcePlacementTwo: 'resourcePlacementTwo',
  resourcePlacementFour: 'resourcePlacementFour',

  lineShape: 'lineShape',
  addToLine: 'addToLine',
  lineDrilldown: 'lineDrilldown',
  lineTheme: 'lineTheme',
  addToBoxes: 'addToBoxes',

  align: 'align',
  top: 'top',
  bottom: 'bottom',
  middleHorizontal: 'middleHorizontal',
  middleVertical: 'middleVertical',
  left: 'left',
  right: 'right',

  distribute: 'distribute',
  horizontally: 'horizontally',
  vertically: 'vertically',

  matchSize: 'matchSize',
  widthHeight: 'widthHeight',
  width: 'width',
  height: 'height',

  font: 'changeFont',
  tags: 'changeTags'
};

const baseDrilldownMenuItems = [
  menuItems.importDrilldown,
  menuItems.exportDrilldown,
  menuItems.deleteDrilldown,
  menuItems.sendToChild,
  menuItems.useExistingDiagram
];

const subMenu = {
  drilldown: {
    title: menuItems.drilldownMenuTitle,
    items: baseDrilldownMenuItems
  },

  addDocumentation: {
    title: menuItems.addDocumentation,
    items: [
      menuItems.attachNote,
      menuItems.attachUrl,
      menuItems.attachDataTable,
      menuItems.attachImage,
      menuItems.refModelNode,
      menuItems.copiedOrgModelNode,
      menuItems.requirement,
      menuItems.orgModelNode,
      menuItems.proposedNode
    ]
  },

  selection: {
    title: menuItems.selectionMenu,
    items: [
      menuItems.selectAll,
      menuItems.selectBoxes,
      menuItems.selectVertices,
      menuItems.selectEdges
    ]
  },

  addChange: {
    title: menuItems.addChange,
    items: [
      menuItems.addRequirement,
      menuItems.generateRequirement,
      menuItems.addStory,
      menuItems.generateStoriesAI,
      menuItems.pasteRequirementLink,
      menuItems.pasteStoryLink
    ]
  },

  align: {
    title: menuItems.align,
    items: [
      menuItems.top,
      menuItems.middleVertical,
      menuItems.bottom,
      menuItems.left,
      menuItems.middleHorizontal,
      menuItems.right
    ]
  },

  distribute: {title: menuItems.distribute, items: [menuItems.vertically, menuItems.horizontally]},

  matchSize: {
    title: menuItems.matchSize,
    items: [menuItems.widthHeight, menuItems.width, menuItems.height]
  },

  addChangeRecord: {
    title: menuItems.addChange,
    items: [menuItems.generateRequirements, menuItems.generateStoriesAI]
  },

  addToBoxes: {title: menuItems.addToBoxes, items: [menuItems.addResource]},

  drilldownSubMenu: {title: menuItems.drilldown, items: [menuItems.sendToChild]},

  themePasteMenu: {
    title: menuItems.theme,
    items: [menuItems.pasteStyle]
  },

  addToCard: {
    title: menuItems.addToCard,
    items: [menuItems.addAttribute, menuItems.addResource, menuItems.addFooterText]
  },

  theme: {
    title: menuItems.theme,
    items: [menuItems.formatActivityThemes, menuItems.copyStyle, menuItems.pasteStyle]
  },

  placement: {
    title: menuItems.placement,
    items: [menuItems.toFront, menuItems.toBack, menuItems.lock, menuItems.unlock]
  },

  resources: {
    title: menuItems.resourcePlacement,
    items: [
      menuItems.resourcePlacementRow,
      menuItems.resourcePlacementTwo,
      menuItems.resourcePlacementFour
    ]
  },

  lineShape: {
    title: menuItems.lineShape,
    items: [
      menuItems.choosePoints,
      menuItems.clearWaypoints,
      menuItems.makeStraight,
      menuItems.reverseLine
    ]
  },

  addToLine: {
    title: menuItems.addToLine,
    items: [
      menuItems.addStartText,
      menuItems.addEndText,
      menuItems.addInteraction,
      menuItems.deleteInteraction
    ]
  },

  lineDrilldown: {
    title: menuItems.lineDrilldown,
    items: [menuItems.sendToChild]
  },

  lineTheme: {
    title: menuItems.lineTheme,
    items: [menuItems.formatLineStyle, menuItems.pasteStyle, menuItems.copyStyle]
  },

  filterStickers: {
    title: menuItems.filterStickers,
    items: [
      menuItems.filterStickersByUser,
      menuItems.filterStickersByColor,
      menuItems.filterStickersByTag
    ]
  }
};

const menuModel = {
  view: {
    canvas: [
      menuItems.separator,
      menuItems.zoomIn,
      menuItems.zoomOut,
      menuItems.fitWindow,
      menuItems.separator,
      menuItems.addSticker,
      menuItems.hideStickers,
      menuItems.showStickers,
      subMenu.filterStickers
    ],

    selection: {
      one: {
        sticker: [menuItems.color, menuItems.tags, menuItems.font, menuItems.delete]
      }
    }
  },
  edit: {
    canvas: [
      menuItems.separator,
      subMenu.selection,
      menuItems.separator,
      menuItems.zoomIn,
      menuItems.zoomOut,
      menuItems.fitWindow,
      menuItems.separator,
      menuItems.hideStickers,
      menuItems.showStickers,
      subMenu.filterStickers,
      menuItems.addImage,
      menuItems.smartRenumber,
      menuItems.makeAllLinesStraight,
      menuItems.separator,
      menuItems.paste
    ],

    selection: {
      one: {
        activity: [
          subMenu.addDocumentation,
          subMenu.addToCard,
          menuItems.renumberActivity,
          menuItems.separator,
          subMenu.drilldown,
          menuItems.separator,
          subMenu.theme,
          menuItems.makeContainerCard,
          menuItems.makeNormalCard,
          subMenu.placement,
          subMenu.resources,
          menuItems.separator,
          menuItems.addToLegend,
          menuItems.copy,
          menuItems.delete
        ],

        flowline: [
          menuItems.addActivity,
          menuItems.addConnector,
          menuItems.addTerminator,
          menuItems.separator,
          subMenu.lineShape,
          subMenu.addToLine,
          subMenu.lineDrilldown,
          subMenu.lineTheme,
          menuItems.separator,
          menuItems.addToLegend,
          menuItems.copy,
          menuItems.delete
        ],

        text: [
          menuItems.addItemLink,
          menuItems.separator,
          menuItems.formatTextThemes,
          menuItems.pasteStyle,
          menuItems.copyStyle,
          menuItems.copy,
          menuItems.delete,
          menuItems.separator,
          menuItems.sendToChild,
          menuItems.separator,
          menuItems.lock,
          menuItems.unlock
        ],

        sticker: [
          menuItems.color,
          menuItems.tags,
          menuItems.font,
          menuItems.copyStyle,
          menuItems.pasteStyle,
          menuItems.separator,
          menuItems.copy,
          menuItems.delete,
          menuItems.separator,
          menuItems.sendToChild,
          menuItems.separator,
          menuItems.lock,
          menuItems.unlock
        ],

        image: [
          menuItems.addItemLink,
          menuItems.separator,
          menuItems.copy,
          menuItems.delete,
          menuItems.separator,
          menuItems.sendToChild,
          menuItems.separator,
          menuItems.lock,
          menuItems.unlock
        ],

        connector: [
          menuItems.copyConnectorLink,
          menuItems.pasteConnectorLink,
          menuItems.separator,
          menuItems.formatConnectorThemes,
          menuItems.delete
        ],

        terminator: [menuItems.formatTerminatorThemes, menuItems.delete]
      },

      some: {
        shuffle: [
          subMenu.drilldownSubMenu,
          subMenu.themePasteMenu,
          subMenu.placement,
          menuItems.separator,
          subMenu.align,
          subMenu.distribute,
          subMenu.matchSize,
          menuItems.separator,
          menuItems.copy,
          menuItems.delete
        ],
        flowline: [
          menuItems.copy,
          menuItems.delete,
          menuItems.separator,
          menuItems.pasteStyle,
          menuItems.separator,
          menuItems.sendToChild
        ],
        text: [
          menuItems.copy,
          menuItems.delete,
          menuItems.separator,
          menuItems.pasteStyle,
          menuItems.separator,
          menuItems.sendToChild,
          menuItems.separator,
          menuItems.lock,
          menuItems.unlock
        ],
        sticker: [
          subMenu.drilldownSubMenu,
          subMenu.themePasteMenu,
          subMenu.placement,
          menuItems.separator,
          subMenu.align,
          subMenu.distribute,
          subMenu.matchSize,
          menuItems.separator,
          menuItems.copy,
          menuItems.delete
        ],
        image: [
          menuItems.copy,
          menuItems.delete,
          menuItems.separator,
          menuItems.sendToChild,
          menuItems.separator,
          menuItems.lock,
          menuItems.unlock
        ],
        terminator: [menuItems.delete],
        connector: [menuItems.delete],

        activity: [
          subMenu.addChangeRecord,
          subMenu.addToBoxes,
          subMenu.drilldownSubMenu,
          menuItems.separator,
          subMenu.themePasteMenu,
          subMenu.placement,
          menuItems.separator,
          subMenu.resources,
          menuItems.toFront,
          menuItems.toBack,
          subMenu.align,
          subMenu.distribute,
          subMenu.matchSize,
          menuItems.separator,
          menuItems.copy,
          menuItems.delete
        ]
      }
    }
  }
};

export {menuItems, subMenu, menuModel};
